import { atom } from "recoil";

const carListAtom = atom({

    key:"carList",
    default: null

});

export default carListAtom;